import $ from 'jquery';

let table = $('.js-city-directory').dataTable({
  "pageLength": 25,
});

$(table.api().table().container()).addClass('c-datatables');
